/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.TechnicalAnalysis.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface ChartData
 */
export interface ChartData {
    /**
     * 
     * @type {number}
     * @memberof ChartData
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartData
     */
    'close'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChartData
     */
    'signal'?: string;
}
/**
 * 
 * @export
 * @interface DateTime
 */
export interface DateTime {
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'day'?: number;
}
/**
 * 
 * @export
 * @interface EpsReplay
 */
export interface EpsReplay {
    /**
     * 
     * @type {Array<Expec>}
     * @memberof EpsReplay
     */
    'exp'?: Array<Expec>;
    /**
     * 
     * @type {string}
     * @memberof EpsReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Expec
 */
export interface Expec {
    /**
     * 
     * @type {string}
     * @memberof Expec
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Expec
     */
    'quarter'?: string;
    /**
     * 
     * @type {number}
     * @memberof Expec
     */
    'eps'?: number;
    /**
     * 
     * @type {number}
     * @memberof Expec
     */
    'EPSForecast'?: number;
    /**
     * 
     * @type {number}
     * @memberof Expec
     */
    'Surprise'?: number;
}
/**
 * 
 * @export
 * @interface Indicator
 */
export interface Indicator {
    /**
     * 
     * @type {string}
     * @memberof Indicator
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Indicator
     */
    'score'?: string;
    /**
     * 
     * @type {number}
     * @memberof Indicator
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicator
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicator
     */
    'tooltipId'?: number;
}
/**
 * 
 * @export
 * @interface RecReplay
 */
export interface RecReplay {
    /**
     * 
     * @type {Array<Recom>}
     * @memberof RecReplay
     */
    'recom'?: Array<Recom>;
    /**
     * 
     * @type {string}
     * @memberof RecReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Recom
 */
export interface Recom {
    /**
     * 
     * @type {string}
     * @memberof Recom
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof Recom
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof Recom
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface Replay
 */
export interface Replay {
    /**
     * 
     * @type {string}
     * @memberof Replay
     */
    'error'?: string;
    /**
     * 
     * @type {Array<Indicator>}
     * @memberof Replay
     */
    'tableValues'?: Array<Indicator>;
    /**
     * 
     * @type {Array<ChartData>}
     * @memberof Replay
     */
    'chartValues'?: Array<ChartData>;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}

/**
 * TechnicalAnalysisServiceApi - axios parameter creator
 * @export
 */
export const TechnicalAnalysisServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {boolean} [daily] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        technicalanalysisFetchDataGet: async (identityToken: string, entityId?: string, daily?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('technicalanalysisFetchDataGet', 'identityToken', identityToken)
            const localVarPath = `/technicalanalysis/fetch-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (daily !== undefined) {
                localVarQueryParameter['daily'] = daily;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        technicalanalysisFetchExpectationsGet: async (identityToken: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('technicalanalysisFetchExpectationsGet', 'identityToken', identityToken)
            const localVarPath = `/technicalanalysis/fetch-expectations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        technicalanalysisFetchRecommendationsGet: async (identityToken: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('technicalanalysisFetchRecommendationsGet', 'identityToken', identityToken)
            const localVarPath = `/technicalanalysis/fetch-recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TechnicalAnalysisServiceApi - functional programming interface
 * @export
 */
export const TechnicalAnalysisServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TechnicalAnalysisServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {boolean} [daily] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async technicalanalysisFetchDataGet(identityToken: string, entityId?: string, daily?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Replay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.technicalanalysisFetchDataGet(identityToken, entityId, daily, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async technicalanalysisFetchExpectationsGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpsReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.technicalanalysisFetchExpectationsGet(identityToken, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async technicalanalysisFetchRecommendationsGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.technicalanalysisFetchRecommendationsGet(identityToken, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TechnicalAnalysisServiceApi - factory interface
 * @export
 */
export const TechnicalAnalysisServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TechnicalAnalysisServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {boolean} [daily] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        technicalanalysisFetchDataGet(identityToken: string, entityId?: string, daily?: boolean, options?: any): AxiosPromise<Replay> {
            return localVarFp.technicalanalysisFetchDataGet(identityToken, entityId, daily, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        technicalanalysisFetchExpectationsGet(identityToken: string, entityId?: string, options?: any): AxiosPromise<EpsReplay> {
            return localVarFp.technicalanalysisFetchExpectationsGet(identityToken, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        technicalanalysisFetchRecommendationsGet(identityToken: string, entityId?: string, options?: any): AxiosPromise<RecReplay> {
            return localVarFp.technicalanalysisFetchRecommendationsGet(identityToken, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TechnicalAnalysisServiceApi - object-oriented interface
 * @export
 * @class TechnicalAnalysisServiceApi
 * @extends {BaseAPI}
 */
export class TechnicalAnalysisServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {boolean} [daily] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnicalAnalysisServiceApi
     */
    public technicalanalysisFetchDataGet(identityToken: string, entityId?: string, daily?: boolean, options?: AxiosRequestConfig) {
        return TechnicalAnalysisServiceApiFp(this.configuration).technicalanalysisFetchDataGet(identityToken, entityId, daily, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnicalAnalysisServiceApi
     */
    public technicalanalysisFetchExpectationsGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig) {
        return TechnicalAnalysisServiceApiFp(this.configuration).technicalanalysisFetchExpectationsGet(identityToken, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnicalAnalysisServiceApi
     */
    public technicalanalysisFetchRecommendationsGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig) {
        return TechnicalAnalysisServiceApiFp(this.configuration).technicalanalysisFetchRecommendationsGet(identityToken, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}



